import type {
  EnrollmentForecastPoint,
  EnrollmentForecastSeries,
  OnboardingMonthRow,
} from "./onboardingPlots.types";

function emptyPoint(date: string): EnrollmentForecastPoint {
  return { date, p10: null, p50: null, p90: null };
}

export function buildEnrollmentForecastSeries(
  rows: OnboardingMonthRow[],
): EnrollmentForecastSeries {
  const sorted = [...rows].sort((a, b) => a.date.localeCompare(b.date));
  let cutoffIndex = -1;
  for (let index = sorted.length - 1; index >= 0; index -= 1) {
    if (sorted[index].enrolledCumulative != null) {
      cutoffIndex = index;
      break;
    }
  }

  const hasExplicitForecast = sorted.some(
    (row) =>
      row.forecastEnrolledCumulativeP10 != null ||
      row.forecastEnrolledCumulativeP50 != null ||
      row.forecastEnrolledCumulativeP90 != null,
  );

  if (cutoffIndex < 0 || !hasExplicitForecast) {
    return { points: [], hasForecast: false };
  }

  return {
    hasForecast: true,
    points: sorted.map((row, index) => {
      if (index < cutoffIndex) return emptyPoint(row.date);
      if (index === cutoffIndex) {
        const anchor = row.enrolledCumulative;
        return {
          date: row.date,
          p10: anchor,
          p50: anchor,
          p90: anchor,
        };
      }

      return {
        date: row.date,
        p10: row.forecastEnrolledCumulativeP10 ?? null,
        p50: row.forecastEnrolledCumulativeP50 ?? null,
        p90: row.forecastEnrolledCumulativeP90 ?? null,
      };
    }),
  };
}
